import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const allRapport = createAsyncThunk("rapportcommercial/allRapport", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/allRapport", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});


export const verifRapportScrap = createAsyncThunk("rapportcommercial/verifRapportScrap", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/verifRapportScrap", {
    method: 'POST',
    headers: {          
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});

export const getVerifMoisRapport = createAsyncThunk("rapportcommercial/getVerifMoisRapport", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/getVerifMoisRapport", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});


export const allRapportBi = createAsyncThunk("rapportcommercial/allRapportBi", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/allRapportBi", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const getDetailRapport = createAsyncThunk("rapportcommercial/getDetailRapport", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/getDetailRapport/"+id, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});

export const updateRapport = createAsyncThunk("rapportcommercial/updateRapport", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/updateRapport/"+action.idBl, {
    method: 'put',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});


export const getFileRapport = createAsyncThunk("rapportcommercial/getFileRapport", async (file) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/getFileRapport/"+file, {
    method: "GET",
    responseType: "blob",    
  }).then(response => response.blob())
  .then(function(myBlob) {
    return((myBlob))
  })
  .catch((error) => {
    console.log(error);
  })
  const files = await response;
  return files;
});
export const allRapportList = createAsyncThunk("rapportcommercial/allRapportList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/allRapportList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});

export const SuivieRapportList = createAsyncThunk("rapportcommercial/SuivieRapportList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/SuivieRapportList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const exportRapport = createAsyncThunk("rapportcommercial/exportRapport", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/exportRapport", {
    method: 'POST',
    headers: {          
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const cheeckProduit = createAsyncThunk("rapportcommercial/cheeckProduit", async (action) => { 
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/cheeckProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)

  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});

//upload BL file
export const saveFile = createAsyncThunk("rapportcommercial/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token':token,
    },
    body:action
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const extractionsRapport = createAsyncThunk("bl/extractionsRapport", async (action) => {
  /* new http://54.36.182.30:81/ocr */
  /* old http://40.67.198.7:92/submit */

  ///http://54.36.182.30:81/ocr
  const urlOcr = process.env.REACT_APP_OCR_API_URL;
  const response = await fetch(urlOcr, {
    method: "POST",
    headers: { Accept: "application/*" },
    body: action,
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const rapportcommercialAdded = createAsyncThunk("rapportcommercial/rapportcommercialAdded", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/rapportcommercialAdded", {
    method: 'POST',
    headers: {          
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const rapportcommercialAddedExcel = createAsyncThunk("rapportcommercial/rapportcommercialAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/rapportcommercialAddedExcel", {
    method: 'POST',
    headers: {          
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
export const verifRapport = createAsyncThunk("rapportcommercial/verifRapport", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "rapportcommercial/verifRapport", {
    method: 'POST',
    headers: {          
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body:JSON.stringify(action)
  });
  const rapportcommercial = await response.json();
  return rapportcommercial;
});
const rapportcommercialReduce = createSlice({
  name: "rapportcommercial",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
   
    deleterapportcommercial(state, action) {
      const { id } = action.payload;
      fetch(Configuration.BACK_BASEURL + "rapportcommercial/delete/"+id, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(allRapport.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(allRapport.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(allRapport.rejected, (state, action) => {
        state.loading = false;
      });
  },
  
});

export const {deleterapportcommercial  } = rapportcommercialReduce.actions;

export default rapportcommercialReduce.reducer;
